import { GET_USERS, SET_USER_LOADING } from '../types';

const initialState = {
  users: {},
  loading: true
};

export default function(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_USERS:
      return {
        ...payload,
        loading: false
      };
    case SET_USER_LOADING:
      return {
        ...state,
        loading: payload
      };
    default:
      return state;
  }
}
